import { SelectableItemOptions } from "client/Hooks";
import { createContext } from "react";

export type RootContextData = {
	doesSupportMultiSelect: boolean;
	containerWidth: number;
	contentWidth: number;
	hasZebraPrinting: boolean;
	shouldHideDisabledCheckboxes: boolean;
};

export const RootContext = createContext<RootContextData>({
	doesSupportMultiSelect: false,
	containerWidth: 0,
	contentWidth: 0,
	hasZebraPrinting: false,
	shouldHideDisabledCheckboxes: false
});

export type RowVariant =
	| "odd"
	| "even"
	| "default";

export type RowContextData = {
	hasHover: boolean;
	onExecute?(): void;
	selectable: SelectableItemOptions;
	isDisabled: boolean;
	shouldHideDisabledCheckboxes: boolean;
};

export const RowContext = createContext<RowContextData>({
	hasHover: false,
	selectable: false,
	shouldHideDisabledCheckboxes: false,
	isDisabled: false
});

export type BodyRowContextIndexData = number;
export const BodyRowIndexContext = createContext<BodyRowContextIndexData>(-1);

export type RowCellContextIndexData = number;
export const RowCellIndexContext = createContext<RowCellContextIndexData>(-1);

export type ColumnContextData = {
	isExpensiveToRender: boolean;
	trackingId: string;
	maxWidthOfAutoColumn: number | undefined;
};

export type ColumnsContextData = {
	columns: readonly ColumnContextData[];
};

export const ColumnsContext = createContext<ColumnsContextData>({
	columns: []
});